var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"radio-icon__container"},[((!_vm.checked))?_c('es-icon',{attrs:{"name":"circle","size":(_vm.size),"color":"#D4D3D3"}}):_c('es-icon',{attrs:{"name":"dot-circle","size":(_vm.size),"color":"#1473ff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }